export function currencyFormat(num) {
   return 'Rp. ' + Number(num).toFixed(0).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.')
}

export function currencyFormatPrint(num) {
   return 'Rp' + Number(num).toFixed(0).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.')
}